import Swal from "sweetalert2";



export const showApiAlert = (response) => {
  Swal.fire({
    icon: response.icon || (response.ok ? "success" : "error"),
    title: response.title || (response.ok ? "Éxito" : "Error"),
    text: response.msg || "Ocurrió un problema inesperado",
    confirmButtonText: "Aceptar",
  });
};